import { PROJECT_ID } from "config/keys/user";
import { getApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";
import { REGION } from "store/ref";

const app = getApp(PROJECT_ID);
const functions = getFunctions(app, REGION);

// get functions api.
export const getApiFunctions = () => {
  // :::::::::::: LOGIN :::::::::::::://

  // login operator.
  const login = httpsCallable(functions, "api-operator-login-token");

  // generate token for bailiff.
  const generateToken = httpsCallable(
    functions,
    "api-login-bailiff-token-generate",
  );

  // hàm add pin code.
  const emailSendCode = httpsCallable(
    functions,
    "api-email-verification-add-pincode",
  ); // { email, source },
  const emailCheckCode = httpsCallable(
    functions,
    "api-email-verification-check-pincode",
  ); // { email, source, pincode},

  // :::::::::::: WITH CLIENTS :::::::::::::://
  const addClient = httpsCallable(functions, "api-reseller-add-client"); // {id, clients, notes}
  const updateClient = httpsCallable(functions, "api-reseller-update-client"); // {id, clients}
  const deleteClient = httpsCallable(functions, "api-reseller-delete-client"); //{id}

  // :::::::::::: AGOLIA :::::::::::::::::::://

  // search email.
  const searchUserEmail = httpsCallable(functions, "api-reseller-search-email"); // {email}
  const searchUserId = httpsCallable(functions, "api-reseller-scan-id"); // {uid},

  // return.
  return {
    login,
    email: {
      emailSendCode,
      emailCheckCode,
    },
    generateToken,
    reseller: {
      searchUserEmail,
      searchUserId,
      addClient,
      updateClient,
      deleteClient,
    },
  };
};
